import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionHeader from '../components/SectionHeader';

const AboutSection = styled.section`
  background-color: var(--dark-color);
`;

const AboutContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AboutText = styled.div`
  max-width: 800px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  p {
    font-size: 1.2rem;
    line-height: 1.8;
    
    @media (max-width: 576px) {
      font-size: 1rem;
    }
  }
`;

const About = () => {
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('about-text');
      if (!element) return;
      
      const position = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      if (position.top < windowHeight * 0.75) {
        element.classList.add('animate');
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <AboutSection id="sobre">
      <div className="container">
        <SectionHeader title="Sobre Dev Team Six" highlight="Dev Team Six" />
        <AboutContent>
          <AboutText id="about-text">
            <p>
              Somos uma equipe de elite em desenvolvimento de software, unindo
              estratégia, disciplina e código para transformar negócios
              com precisão e impacto. Combinamos excelência técnica com uma abordagem
              estratégica sólida para enfrentar os desafios mais complexos do mercado 
              digital e entregar soluções de alto desempenho.
            </p>
          </AboutText>
        </AboutContent>
      </div>
    </AboutSection>
  );
};

export default About;
